'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowUUp, iconArrowUUpTag } from '@ni/nimble-components/dist/esm/icons/arrow-u-up';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowUUp };
export { iconArrowUUpTag };
export const NimbleIconArrowUUp = wrap(IconArrowUUp);